import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tags: {
    [BillingMode.Stripe]: 'Kosten via betaalmethode',
    [BillingMode.InternalInvoicing]: 'Kosten via omzet',
    active: 'Actief',
    on_trial: 'In proefperiode',
    launch_pending: 'In de wacht tot lanceerdatum',
    billing_disabled: 'Facturering uitgeschakeld',
    on_grace_period: 'In respijtperiode',
    past_due: 'Achterstallig',
    cancelled: 'Geannuleerd',
  },
};
